import { API, axiosInstance } from "lib";


export const actionPermissionApi = (data = {}) => {
  return axiosInstance
    .post(API.ACTION_PERMISSION, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const subscriptionListApi = (data = {}) => {
  return axiosInstance
    .post(API.SUBSCRIPTION_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        return err?.response?.data
      }

    });
};

export const planComparision = (data = {}) => {
  return axiosInstance
    .post(API.COMPARISION_PALN, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        return err?.response?.data
      }

    });
};

export const createOrderPayment = (data = {}) => {
  return axiosInstance
    .post(API.CREATE_ORDER_PAYMENT, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        return err?.response?.data
      }

    });
};

export const paymentVerifyApi = (data = {}) => {
  return axiosInstance
    .post(API.PAYMENT_VERIFY, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        return err?.response?.data
      }

    });
};

export const applyDiscountCodeApi = (data = {}) => {
  return axiosInstance
    .post(API.DISCOUNT_CODE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        return err?.response?.data
      }

    });
}


